const FALLBACK_IMAGE = '/assets/images/commercialPDP/hero.jpg';

const HeroBackground = ({ imageUrl, altText, onImageError, hasError }) => {
  const imgSrc = (imageUrl && !hasError) ? imageUrl : FALLBACK_IMAGE;

  return (
    <div className="commercial-hero__background commercial-hero__background--has-image">
      <img
        src={imgSrc}
        alt={altText || 'Property hero image'}
        fetchpriority="high"
        onError={onImageError}
        className="commercial-hero__background-img"
      />
    </div>
  );
};

export default HeroBackground;
